<template>
    <div> 
    <div class="container">   
        <h1 class="is-size-4 mb-50 mt-50 radley">Showing Results for: <em>{{tag}}</em></h1>  
    </div>
        <div class="container">
            <div class="masonry">
                <div class="item" v-for="recipe in recipes" :key="recipe.id">                       
                    <figure class="image">
                        <img v-if="recipe.mainImage.length" :src="'https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + recipe.mainImage[0] + '?alt=media'">
                        <img v-else src="https://bulma.io/images/placeholders/480x480.png">
                    </figure>      
                    <div class="middle">
                        <div class="top-left">
                            <p class="recipe-card-title">
                                <router-link :to="{name: 'recipe', params: {id: recipe.id, slug: recipe.slug}}">  
                                    {{recipe.name}}   
                                </router-link>                                
                            </p>                                  
                            <p class="has-text-white">Made By 
                                <router-link :to="{name: 'Kitchen', params: {id: recipe.user_id}}">
                                    <strong class="has-text-white">{{recipe.kitchen_name}}</strong>
                                </router-link>
                            </p> 
                        </div>
                        <div class="top-right">
                            <Like :recipe="recipe" :key="recipe.id"></Like>
                        </div>
                        <div class="bottom-left">
                            <time class="has-text-white">{{ recipe.created_at.toDate() | moment("from", "now") }}</time>   
                        </div>
                        <div class="bottom-right">
                            <button class="button is-primary add-rounded" slot="trigger"                            
                                @click="openModal(recipe.id)">
                                <b-icon icon="plus"></b-icon>
                            </button>                        
                        </div>
                    </div>   
                </div> 
            </div>
                <b-modal :active.sync="isComponentModalActive"
                    has-modal-card
                    trap-focus
                    aria-role="dialog"
                    aria-modal>                
                    <Add :userMeals="user_meals" :menus="menus" :selectedRecipe="selectedRecipe" :userData="userData"></Add>
                </b-modal>     
        </div> 
         
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import firebase from '@/firebase';
import db from '@/db';
import Like from '../components/Like.vue';
import Add from '../components/Add.vue';


export default {
    data() {
        return {            
            isComponentModalActive: false,
            selectedRecipe:null,
            userData: null,
            tag: this.$route.params.id
        }
    },
    mounted() {
        this.init();
        let user = firebase.auth().currentUser;
        if (user) {
        db.collection('users').doc(firebase.auth().currentUser.uid)
            .get().then(docSnapshot => {
                if (!docSnapshot.exists) return;
                this.userData = docSnapshot.data();
            });
        }
    },
    components: {
        Like,
        Add
    },
    computed: mapState('tagged', ['recipes', 'user_meals', 'menus', 'user']),
    methods: {        
        openModal(recipe) {
            if(this.userData) {
                this.isComponentModalActive = true;
                this.selectedRecipe = recipe;
            }
        },
        ...mapActions('tagged', ['init']),
    }
};
</script>